var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9277 18.2992L21 18.2125L20.9825 18.1013C20.5223 15.1021 18.9554 12.693 16.5701 11.3161L16.4006 11.2183L16.2654 11.36C15.1389 12.5414 13.6239 13.1922 11.9997 13.1922C10.3754 13.1922 8.8604 12.5419 7.73387 11.36L7.59872 11.2183L7.42917 11.3161C5.04393 12.693 3.47705 15.1021 3.01726 18.1013L3.00031 18.2125L3.07212 18.2992C4.70882 20.2629 6.71847 21.6202 8.91145 22.277L7.97665 20.4423C8.28279 20.5925 9.04586 21.3497 9.89342 22.1907C10.0278 22.3241 10.1643 22.4595 10.3014 22.595C10.8599 22.6843 11.427 22.7296 12.0002 22.7296C14.3147 22.7296 16.5332 21.9897 18.4666 20.6036L17.4184 17.0036L19.5226 19.7567C20.0157 19.3164 20.4854 18.83 20.9277 18.2992ZM16.8201 8.96873C15.9501 10.7544 14.1164 11.9878 12.0002 11.9878C9.04592 11.9878 6.64223 9.58314 6.64223 6.6294C6.64223 3.67567 9.04592 1.27148 12.0002 1.27148C14.9544 1.27148 17.3581 3.67567 17.3581 6.6299C17.3581 7.12501 17.2906 7.60466 17.1643 8.06012L16.1044 8.40681L16.8201 8.96873Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.3da01f6df632dae3e70583ce4b6c9a3d.svg";
export { ForwardRef as ReactComponent };